import { render } from "./AdminView.vue?vue&type=template&id=5076d4d7&scoped=true"
import script from "./AdminView.vue?vue&type=script&lang=js"
export * from "./AdminView.vue?vue&type=script&lang=js"

import "./AdminView.vue?vue&type=style&index=0&id=5076d4d7&scoped=true&lang=css"
import "./AdminView.vue?vue&type=style&index=1&id=5076d4d7&scoped=true&lang=css"
import "./AdminView.vue?vue&type=style&index=2&id=5076d4d7&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5076d4d7"]])

export default __exports__